<template>
  <v-card
    ref="screen"
    :class="{ 'mb-2': !inModal, ...classes }"
    class="screen"
    light
  >
    <div v-if="useAmount">
      <span>{{ $t('words.amount') }}</span>
      <span>{{ $amount() }}</span>
    </div>
    <div
      v-if="title !== null"
      :class="infoclass"
    >
      <span>
        {{ title }}
        <v-btn
          v-if="useHelp"
          absolute
          right
          icon
          outlined
          x-small
          @click="$emit('help')"
        >
          <v-icon>mdi-help</v-icon>
        </v-btn>
      </span>
      <span><i :style="`font-style: inherit;font-size: ${infoPercentSize}%`">{{ info }}</i></span>
    </div>
    <div
      v-if="titlesup !== null"
      :class="infosupclass"
    >
      <span>{{ titlesup }}</span>
      <span><i :style="`font-style: inherit;font-size: ${infoSupPercentSize}%`">{{ infosup }}</i></span>
    </div>
  </v-card>
</template>

<script>
import { $amount } from '@/modules/Utils'

export default {
  name: 'Screen',

  props: {
    useAmount : { type: Boolean, default: false },
    useHelp : { type: Boolean, default: false },
    title: { type: String, default: null },
    info: { type: [String, Number], default: null },
    infoclass: { type: String, default: '' },
    titlesup: { type: String, default: null },
    infosup: { type: [String, Number], default: null },
    infosupclass: { type: String, default: '' },
    inModal : { type: Boolean, default: false }
  },

  data () {
    return {
      defaultParentWidth: null,
      infoPercentSize: 100,
      infoSupPercentSize: 100
    }
  },

  computed: {
    isMobil () { return this.$store.getters.isMobil },
    amount () { return this.$store.state.amount },
    classes () {
      return {
        'screen-is-one': (
          this.useAmount && this.title === null && this.titlesup === null
        ) || (
          !this.useAmount && this.title !== null && this.titlesup === null
        ),
        'screen-is-two': (
          this.useAmount && this.title !== null && this.titlesup === null
        ) || (
          !this.useAmount && this.title !== null && this.titlesup !== null
        ),
        'screen-is-three': this.useAmount && this.title !== null && this.titlesup !== null
      }
    }
  },

  watch: {
    info (val) {
      if (this.defaultParentWidth === null) this.defaultParentWidth = this.$refs.screen.$el.offsetWidth
      const width = val ? (val.length * 22.25) : 1
      this.infoPercentSize = width >= this.defaultParentWidth ? ((this.defaultParentWidth / width) * 100) : 100
    },
    infosup (val) {
      if (this.defaultParentWidth === null) this.defaultParentWidth = this.$refs.screen.$el.offsetWidth
      const width = val ? (val.length * 22.25) : 1
      this.infoSupPercentSize = width >= this.defaultParentWidth ? ((this.defaultParentWidth / width) * 100) : 100
    }
  },

  methods: {
    $amount
  }
}
</script>

<style lang="scss" scoped>
.screen {
  background-color: #fefefe;
  color: #272525;

  span {
    white-space: nowrap;
  }

  & div {
    text-align: right;

    & span:first-child {
      float: left;
      font-weight: 500;
      padding-left: 8px;
      margin-top: 4px;
    }

    & span:last-child {
      padding-right: 8px;
    }
  }

  & div:first-child  {
    & span:last-child {
      font-size: 40px;
      font-weight: 700;
    }
  }

  & div:last-child {
    padding-top: 20px;

    & span:first-child {
      margin-top: -16px;
    }
  }
}

.screen.screen-is-two {
  & div:first-child {
    & span:last-child {
      font-size: 30px;
      font-weight: 600;
    }
  }

  & div:last-child {
    background: linear-gradient(33deg, #90898e, #444346) top no-repeat;
    background-size: 95% 2px;

    & span:last-child {
      font-size: 40px;
      font-weight: 700;
    }
  }
}

.screen.screen-is-three {
  & div:first-child {
    & span:last-child {
      font-size: 20px;
      font-weight: 600;
    }
  }
  & div:nth-child(2) {
    background: linear-gradient(33deg, #90898e, #444346) top no-repeat;
    background-size: 95% 2px;
    & span:last-child {
      font-size: 30px;
      font-weight: 600;
    }
  }
  & div:last-child {
    background: linear-gradient(33deg, #444346, #90898e) top no-repeat;
    background-size: 95% 2px;
    & span:last-child {
      font-size: 40px;
      font-weight: 700;
    }
  }
}
</style>
